import { create } from "zustand";
import { combine, createJSONStorage } from "zustand/middleware";
import { adminStore } from "./admin.store";
import { authService } from "services/v2/AuthService";
import { ModalService } from "components/util-components/ModalService";
export const authStore = create(
  combine(
    {
      isAuthenticated: false,
      authChecked: false,
      redirectPath: null,
      showLogoutBanner: false,
    },
    (set, get) => ({
      setAuthenticated: (val) => set({ isAuthenticated: val }),
      setAuthChecked: (val) => set({ authChecked: val }),
      setRedirectPath: (path) => set({ redirectPath: path }),
      clearRedirectPath: () => set({ redirectPath: null }),
      setLogoutBanner: (show) => set({ showLogoutBanner: show }),
      reset: () => {
        ModalService.closeAll();
        set({ isAuthenticated: false, redirectPath: null });
        adminStore.getState().setUserProfile(null);
      },
      logout: async () => {
        try {
          await authService.logout();
        } finally {
          ModalService.closeAll();
          set({ isAuthenticated: false, redirectPath: null });
          adminStore.getState().setUserProfile(null);
        }
      },
    }),
  ),
  { name: "park-pay-auth", storage: createJSONStorage(() => sessionStorage) },
);
